export const INTERNAL_ONLY_ERROR = 'internal_only';

export function isInternalOnlyResponse(response) {
  if (!response || response.status !== 403) {
    return false;
  }
  const detail = response.data?.detail;
  if (detail && typeof detail === 'object' && detail.error === INTERNAL_ONLY_ERROR) {
    return true;
  }
  if (typeof detail === 'string' && /internal-only/i.test(detail)) {
    return true;
  }
  return false;
}

export function isInternalOnlySocketError(error) {
  if (!error) return false;
  if (error.error === INTERNAL_ONLY_ERROR) return true;
  if (error.data?.error === INTERNAL_ONLY_ERROR) return true;
  const message = error.message || '';
  return /internal-only/i.test(message);
}
